if (!customElements.get('ja-evotime-pricing')) {
  customElements.define('ja-evotime-pricing', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.number = this.querySelector('[data-employee-count]');
      this.slider = this.querySelector('[data-employee-slider]');
      this.decrease = this.querySelector('[data-employee-decrease]');
      this.increase = this.querySelector('[data-employee-increase]');
      this.lastValidCount = Number(this.slider.value);
      this.rates = [this.dataset.rateOne, this.dataset.rateTwo, this.dataset.rateThree].map(Number);
      this.format = window.JaEvoMath.money(this.dataset.currency);
      this.variants = JSON.parse(this.querySelector('[data-plan-variants]')?.textContent || '[]');
      [[this.decrease, -5], [this.increase, 5]].forEach(([button, step]) => {
        button.addEventListener('click', () => {
          this.number.value = window.JaEvoMath.clamp(this.lastValidCount + step, 10, 500);
          this.update();
        }, options);
      });
      this.slider.addEventListener('input', () => {
        this.number.value = this.slider.value;
        this.update();
      }, options);
      ['input', 'change'].forEach(event => this.number.addEventListener(event, () => this.update(), options));
      // Validate before the native product form's submit listener can send its request.
      this.addEventListener('submit', event => {
        if (event.target !== this.querySelector('[data-purchase] form')) return;
        if (!this.update()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...options, capture: true });
      this.querySelectorAll('[data-band-rate]').forEach(rate => {
        rate.textContent = this.format.format(this.rates[Number(rate.dataset.bandRate)] / 100);
      });
      this.update();
    }
    update() {
      const employees = Number(this.number.value);
      const valid = this.number.value.trim() !== '' && this.number.checkValidity() && window.JaEvoMath.validEmployeeCount(employees);
      this.querySelector('[data-count-error]').hidden = valid;
      this.querySelector('[data-price-details]').hidden = !valid;
      this.number.setAttribute('aria-invalid', String(!valid));
      this.decrease.disabled = valid && employees <= 10;
      this.increase.disabled = valid && employees >= 500;
      if (!valid) {
        this.setPurchase(null);
        return false;
      }
      this.lastValidCount = employees;
      this.slider.value = employees;
      const cost = window.JaEvoMath.annual(employees, this.rates);
      this.querySelector('[data-annual-cost]').textContent = this.format.format(cost / 100);
      const values = {
        employees: String(employees),
        annual_rate: this.format.format(cost / employees / 100),
        monthly_cost: this.format.format(cost / 1200),
        employee_monthly_cost: this.format.format(cost / employees / 1200)
      };
      this.querySelectorAll('[data-price-summary]').forEach(summary => {
        summary.textContent = summary.dataset.template.replace(/\[(employees|annual_rate|monthly_cost|employee_monthly_cost)\]/g, (_, key) => values[key]);
      });
      const variant = window.JaEvoMath.matchAnnualVariant({
        variants: this.variants, employees, cost,
        enabled: this.dataset.cartEnabled === 'true',
        currency: this.dataset.currency, cartCurrency: this.dataset.cartCurrency,
        requiresPlan: this.dataset.requiresPlan === 'true'
      });
      this.setPurchase(variant);
      return Boolean(variant);
    }
    setPurchase(variant) {
      const purchase = this.querySelector('[data-purchase]');
      if (purchase) {
        purchase.hidden = !variant;
        const input = purchase.querySelector('[name="id"]');
        const productForm = purchase.querySelector('product-form');
        const button = purchase.querySelector('[type="submit"]');
        const nextId = String(variant?.id || '');
        if (input.value !== nextId) productForm.handleErrorMessage?.();
        input.value = nextId;
        input.disabled = !variant;
        button.disabled = !variant;
        // Preserve the native loading state while a cart request is in progress.
        if (variant && !button.classList.contains('loading')) productForm.toggleSubmitButton?.(false);
        purchase.querySelector('[data-plan-employees]').value = this.number.value;
      }
      this.querySelector('[data-plan-unavailable]').hidden = Boolean(variant);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
  });
}
